<template>
  <div class="data-down-drawer">
    <!-- 数据下载 -->
    <el-drawer
      title="数据下载"
      class="abnormal data-down"
      :visible.sync="dataDownLoadDrawer"
      :wrapperClosable="false"
      :before-close="handleCloseDataDownLoadDrawer">
      <div class="abnormal-body">
        <div class="abnormal-search">
          <el-date-picker
            v-model="dataDownLoadDaterange"
            class="data-down-date"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-select
            v-model="dataDownLoadOrderType"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in dataDownLoadOrderTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button icon="el-icon-search" class="btn-blue" @click="searchDataDownLoad">搜索</el-button>
          <el-button icon="el-icon-refresh" class="btn-gray" @click="resetDataDownLoad"
            >重置</el-button
          >
        </div>
        <div class="table">
          <div class="title-container">
            <p class="title">下载列表</p>
          </div>
          <el-table ref="table" :data="dataDownLoadTableData" style="width: 100%">
            <el-table-column
              v-for="(item, index) in dataDownLoadTableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              show-overflow-tooltip
              :min-width="item.width"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="120"
            >
              <template slot-scope="scope">
                <el-button
                  class="btn-text"
                  type="text"
                  @click="dataDownload(scope.row)"
                >下载</el-button>
                <el-button
                  class="btn-text"
                  type="text"
                  @click="dataDownloadDel(scope.row.id)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <pagination-tpl
              :total="dataDownLoadTotal"
              :currentPage="dataDownLoadCurrentPage"
              :pageSize="dataDownLoadPageSize"
              @queryChange="dataDownLoadQueryChange"
            ></pagination-tpl>
          </div>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDataDownLoadDrawer">关闭</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import CarrierReconcliation from "models/carrier-reconcliation.js";
import PaginationTpl from "components/base/PaginationTpl";
import { downLoadFile, formaTimeToMinute } from "common/js/util";
export default {
  // dataDownLoadDrawer：数据下载开关
  props: ['dataDownLoadDrawer'],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      // 日期搜索
      dataDownLoadDaterange: '',
      // 承运商类型搜索
      dataDownLoadOrderType: '',
      dataDownLoadOrderTypeList: [
        {id:1, name: '承运商账单'}
      ],
      dataDownLoadOrderTypeObj: {
        1: '承运商账单'
      },
      // 数据下载状态
      dataDownLoadStatusObj: {
        1: '正在生成',
        2: '已生成',
        3: '生成失败 '
      },
      dataDownLoadTotal: 0,
      dataDownLoadCurrentPage: 1,
      dataDownLoadPageSize: 20,
      dataDownLoadTableData: [],
      dataDownLoadTableTitleList: [
        {label: '申请时间', prop: 'createTime', width: '140', showToolTip: false},
        {label: '操作员', prop: 'username', width: '', showToolTip: false},
        {label: '类型', prop: 'typeVal', width: '', showToolTip: true},
        {label: '笔数', prop: 'dataNum', width: '', showToolTip: false},
        {label: '状态', prop: 'statusVal', width: '', showToolTip: false},
        {label: '最后下载时间', prop: 'lastDownloadTime', width: '140', showToolTip: false},
        {label: '下载次数', prop: 'downloadTimes', width: '', showToolTip: false},
      ],
    }
  },

  watch: {
    dataDownLoadDrawer: {
      handler(newVal) {
        if (newVal) this.initTableList()
      }
    }
  },

  created() {
  },

  methods: {
    /** 
     * @desc 数据下载列表
    */
    initTableList() {
      let beginTime = this.dataDownLoadDaterange ? this.dataDownLoadDaterange[0] : ''
      let endTime = this.dataDownLoadDaterange ? this.dataDownLoadDaterange[1] : ''
      let type = this.dataDownLoadOrderType
      let currentPage = this.dataDownLoadCurrentPage
      let data = {
        beginTime,
        endTime,
        type,
        currentPage
      }
      CarrierReconcliation.getBillList(data).then(res => {
        if (res.success) {
          this.dataDownLoadPageSize = res.result.pageSize;
          this.dataDownLoadTotal = res.result.totalNum;
          let arr = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.type = value.type;
            obj.url = value.url;
            obj.typeVal = this.dataDownLoadOrderTypeObj[value.type];
            obj.username = value.username;
            obj.createTime = value.createTime ? formaTimeToMinute(value.createTime): '/';
            obj.lastDownloadTime = value.lastDownloadTime ? formaTimeToMinute(value.lastDownloadTime): '/';
            obj.dataNum = value.dataNum;
            obj.downloadTimes = value.downloadTimes;
            obj.status = value.status;
            obj.statusVal = this.dataDownLoadStatusObj[value.status];
            arr.push(obj);
          });
          this.dataDownLoadTableData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 
     * @desc 关闭数据下载
    */
    handleCloseDataDownLoadDrawer() {
      this.dataDownLoadDaterange = ''
      this.dataDownLoadOrderType = ''
      this.$emit('closeParentDataDownLoadDrawer')
    },

    /** 
     * @desc 搜索数据下载
    */
    searchDataDownLoad() {
      this.dataDownLoadCurrentPage = 1
      this.initTableList();
    },

    /** 
     * @desc 重置
    */
    resetDataDownLoad() {
      this.dataDownLoadDaterange = ''
      this.dataDownLoadOrderType = ''
    },

    /** 
     * @desc 翻页
    */
    dataDownLoadQueryChange(data) {
      this.dataDownLoadCurrentPage = data.currentPage;
      this.initTableList();
    },
    
    /** 
     * @desc 下载数据
    */
    dataDownload(row) {
      let data = {
        id: row.id
      };
      CarrierReconcliation.getModDownloadTimes(data).then(res => {
        if (res.success) {
          this.initTableList();
          this.$message.success("下载成功");
          let fileName = row.url.split('https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/zc/data-download/')[1]?
          row.url.split('https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/zc/data-download/')[1]:'数据报表'
          downLoadFile(fileName,row.url)
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 
     * @desc 删除数据
    */
    dataDownloadDel(id) {
      this.$confirm("删除后不可恢复，是否继续？?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          CarrierReconcliation.getDelBill(id).then(res => {
            if (res.success) {
              this.initTableList();
              this.$message.success("删除成功");
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          });
        })
        .catch(() => {});
    },
  }
}
</script>

<style lang='scss'>

</style>
